import * as XLSX from "xlsx";
import { getEstado } from "./config";

const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

const fullName = (p) => `${p?.nombre || ""} ${p?.apellidos || ""}`.trim();

export function exportAlbaranesExcel(list) {
  const rows = list.map((a) => ({
    "Número": a.numero || "",
    "Fecha": fmtDate(a.createdAt),
    "Estado": getEstado(a.estado).label,
    "Remitente": fullName(a.remitente),
    "DNI remitente": a.remitente?.dni || "",
    "Móvil remitente": a.remitente?.movil || "",
    "Dirección de recogida": a.remitente?.direccion || "",
    "Destinatario": fullName(a.destinatario),
    "DNI destinatario": a.destinatario?.dni || "",
    "Móvil destinatario": a.destinatario?.movil || "",
    "Dirección de entrega": a.destinatario?.direccion || "",
    "Observaciones": a.observaciones || "",
  }));

  const ws = XLSX.utils.json_to_sheet(rows);
  // Anchos de columna razonables
  ws["!cols"] = [
    { wch: 18 }, { wch: 18 }, { wch: 12 }, { wch: 22 }, { wch: 14 },
    { wch: 16 }, { wch: 32 }, { wch: 22 }, { wch: 14 }, { wch: 16 },
    { wch: 32 }, { wch: 40 },
  ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Albaranes");
  const stamp = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `Albaranes_${stamp}.xlsx`);
}
